(()=>{
if(window.MOGA_TRIAL)return;

const HEARTBEAT_MS=30000;
const IDLE_MS=120000;
const INSTALL_KEY='moga_trial_web_install_id_v1';
let info=null;
let timer=null;
let heartbeatTimer=null;
let lastActivity=Date.now();
let foreground=!document.hidden;
let heartbeatBusy=false;
let started=false;

function installId(){
  let v=localStorage.getItem(INSTALL_KEY);
  if(!v){v=crypto.randomUUID();localStorage.setItem(INSTALL_KEY,v)}
  return v;
}
function normPlan(v){
  const s=String(v||'').trim().toUpperCase();
  if(s.includes('PREMIUM'))return'PREMIUM';
  if(s.includes('BASIC'))return'BASIC';
  if(s.includes('PRO'))return'PRO';
  if(s==='NONE'||s==='NO_PLAN'||s.includes('BE PLANO'))return'NONE';
  return'NONE';
}
function realPlan(){return normPlan(window.MOGA_LICENSE_SESSION?.license?.plan)}
function paidExpiredDismissKey(){
  const lic=window.MOGA_LICENSE_SESSION?.license||{};
  const id=String(lic.id||lic.licenseId||lic.code||lic.email||'account').trim();
  return 'moga_trial_paid_expired_dismissed_v1_'+id;
}
function paidExpiredDismissed(){
  try{return localStorage.getItem(paidExpiredDismissKey())==='1'}catch(_){return false}
}
function dismissPaidExpired(){
  try{localStorage.setItem(paidExpiredDismissKey(),'1')}catch(_){}
  document.getElementById('mogaTrialCard')?.remove();
}
function remaining(){
  const raw=Number(info?.remainingSeconds ?? info?.remaining_seconds ?? 0);
  return Math.max(0,Math.floor(Number.isFinite(raw)?raw:0));
}
function status(){return String(info?.status||'').toLowerCase()}
function active(){return status()==='active'&&remaining()>0}
function eligible(){return realPlan()==='BASIC'||realPlan()==='NONE'}
function idle(){return !foreground||(Date.now()-lastActivity)>=IDLE_MS}
function effectivePlan(){return active()?'PREMIUM':realPlan()}
function fmt(sec){sec=Math.max(0,Math.floor(sec));return`${String(Math.floor(sec/60)).padStart(2,'0')}:${String(sec%60).padStart(2,'0')}`}
function expiresText(){
  const raw=info?.expiresAt||info?.expires_at;
  if(!raw)return'';
  const d=new Date(raw);if(Number.isNaN(d.getTime()))return'';
  return d.toLocaleString('lt-LT',{year:'numeric',month:'2-digit',day:'2-digit',hour:'2-digit',minute:'2-digit'});
}
function emit(){
  window.dispatchEvent(new CustomEvent('moga:trial-change',{detail:{info,active:active(),eligible:eligible(),effectivePlan:effectivePlan(),idle:idle()}}));
  try{window.MOGA_PLAN?.apply?.(window.MOGA_LICENSE_SESSION)}catch(_){}
  render();
}
async function api(path,opt={}){
  if(!window.MOGA_CLOUD?.api)throw new Error('MOGA Cloud dar neparuošta.');
  return window.MOGA_CLOUD.api(path,opt);
}
function trialPayload(data){
  // Cloud trial endpointai grąžina { ok, trial: {...} }.
  // Senesnė web logika tikėjosi paties trial objekto, todėl aktyvus trial
  // buvo palaikomas pasibaigusiu (status='' ir remaining=0).
  if(data&&typeof data==='object'&&data.trial&&typeof data.trial==='object')return data.trial;
  return data&&typeof data==='object'?data:{};
}
async function load(){
  if(!eligible()){info={status:'not_needed',remainingSeconds:0};emit();return info}
  try{info=trialPayload(await api('/v1/trial/status'));emit();return info}catch(e){console.warn('MOGA trial status',e);return info}
}
async function startTrial(){
  if(!eligible())return;
  const btn=document.querySelector('[data-moga-trial-start]');if(btn){btn.disabled=true;btn.textContent='AKTYVUOJAMA…'}
  try{
    info=trialPayload(await api('/v1/trial/start',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({deviceId:window.MOGA_CLOUD?.device?.id||window.MOGA_CLOUD?.device?.deviceId||'',installId:installId(),platform:'web'})}));
    lastActivity=Date.now();emit();await heartbeat(true);
  }catch(e){alert(e?.message||'Nepavyko pradėti PREMIUM bandymo.');render()}
}
async function heartbeat(forceActive=null){
  if(heartbeatBusy||!eligible()||!info||status()!=='active')return;
  heartbeatBusy=true;
  try{
    const isActive=forceActive===null?!idle():!!forceActive;
    info=trialPayload(await api('/v1/trial/heartbeat',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({active:isActive,deviceId:window.MOGA_CLOUD?.device?.id||window.MOGA_CLOUD?.device?.deviceId||'',installId:installId(),platform:'web'})}));
    emit();
  }catch(e){console.warn('MOGA trial heartbeat',e)}finally{heartbeatBusy=false}
}
function touch(){
  const wasIdle=idle();lastActivity=Date.now();
  if(wasIdle&&active())heartbeat(true);else render();
}
function localTick(){
  if(active()&&!idle()){
    const key=Object.prototype.hasOwnProperty.call(info,'remainingSeconds')?'remainingSeconds':'remaining_seconds';
    info[key]=Math.max(0,remaining()-1);
    if(remaining()<=0)load();
  }
  render();
}
function ensureStyle(){
  if(document.getElementById('mogaTrialStyle'))return;
  const s=document.createElement('style');s.id='mogaTrialStyle';s.textContent=`
#mogaTrialCard{position:fixed;left:12px;right:auto;bottom:72px;z-index:2147483000;width:min(350px,calc(100vw - 24px));padding:14px 15px;border:1px solid #5a4325;border-radius:16px;background:rgba(17,17,17,.97);color:#fff;box-shadow:0 18px 60px #0008;font-family:Arial,sans-serif}.moga-trial-kicker{font-size:9px;font-weight:900;letter-spacing:1.1px;color:#f4b45f}.moga-trial-title{margin-top:5px;font-size:14px;font-weight:900}.moga-trial-copy{margin-top:6px;color:#aaa;font-size:10px;line-height:1.45}.moga-trial-state{margin-top:8px;font-size:10px;font-weight:900;color:#82dfa2}.moga-trial-state.pause{color:#ffd17b}.moga-trial-state.end{color:#ff9da2}.moga-trial-btn{margin-top:10px;width:100%;border:1px solid #d8872f;border-radius:10px;padding:10px 12px;background:linear-gradient(135deg,#ff9b35,#d96916);color:#111;font-size:10px;font-weight:1000;letter-spacing:.4px;cursor:pointer}.moga-trial-btn:disabled{opacity:.55;cursor:wait}.moga-trial-head{display:flex;align-items:flex-start;gap:10px}.moga-trial-head-main{min-width:0;flex:1}.moga-trial-close{margin:-5px -6px 0 0;width:28px;height:28px;border:0;border-radius:8px;background:transparent;color:#aaa;font-size:18px;line-height:28px;cursor:pointer}.moga-trial-close:hover{background:#ffffff10;color:#fff}@media(max-width:760px){#mogaTrialCard{left:10px;right:10px;bottom:70px;width:auto}}
`;
  document.head.appendChild(s);
}
function render(){
  if(!document.body)return;
  let el=document.getElementById('mogaTrialCard');
  if(!eligible()){el?.remove();return}
  ensureStyle();
  if(!el){el=document.createElement('div');el.id='mogaTrialCard';el.className='screen-only';document.body.appendChild(el)}
  const st=status();
  if(!info){el.innerHTML='<div class="moga-trial-kicker">MOGA SF · PREMIUM BANDYMAS</div><div class="moga-trial-copy">Tikrinama bandomojo laikotarpio būsena…</div>';return}
  if(st==='available'||st==='not_started'||st==='eligible'){
    el.innerHTML='<div class="moga-trial-kicker">IŠBANDYK PREMIUM NEMOKAMAI</div><div class="moga-trial-title">60 min. aktyvaus PREMIUM naudojimo</div><div class="moga-trial-copy">Galioja iki 7 dienų nuo aktyvavimo. Laikas skaičiuojamas tik aktyviai naudojant MOGA SF ir bendras PC bei Android.</div><button class="moga-trial-btn" data-moga-trial-start>PRADĖTI 60 MIN. BANDYMĄ</button>';
    el.querySelector('[data-moga-trial-start]').onclick=startTrial;return;
  }
  if(active()){
    el.innerHTML=`<div class="moga-trial-kicker">PREMIUM BANDYMAS · LIKO ${fmt(remaining())}</div><div class="moga-trial-title">PREMIUM funkcijos atrakintos</div><div class="moga-trial-state ${idle()?'pause':''}">${idle()?'PRISTABDYTAS · pajudink pelę arba paspausk ir tęsk':'AKTYVUS · naudojimo laikas skaičiuojamas'}</div><div class="moga-trial-copy">Bandymas galioja iki ${expiresText()||'7 dienų nuo aktyvavimo'}.</div>`;return;
  }
  if(st==='expired'||st==='used'||st==='finished'||(st==='active'&&remaining()<=0)){
    const base=String(info?.effectivePlan||info?.basePlan||realPlan()).toUpperCase();
    if(base==='NONE'){
      el.innerHTML='<div class="moga-trial-kicker">PREMIUM BANDYMAS BAIGĖSI</div><div class="moga-trial-title">Planas nepasirinktas</div><div class="moga-trial-state end">Duomenys saugiai liko MOGA Cloud</div><div class="moga-trial-copy">Įsigijus planą prieiga bus atkurta pagal pasirinkto plano galimybes. BASIC atidarys BASIC funkcijas, PRO – PRO funkcijas, PREMIUM – visą PREMIUM aplinką. Aukštesnio plano duomenys žemesniame plane neištrinami.</div>';
      setTimeout(()=>{if(location.pathname!=='/pages/sf')location.replace('/pages/sf')},700);
      return;
    }
    if(paidExpiredDismissed()){el.remove();return}
    el.innerHTML='<div class="moga-trial-head"><div class="moga-trial-head-main"><div class="moga-trial-kicker">PREMIUM BANDYMAS BAIGĖSI</div><div class="moga-trial-title">Dabar naudojate '+base+' planą</div></div><button class="moga-trial-close" type="button" aria-label="Uždaryti" title="Uždaryti">×</button></div><div class="moga-trial-state">Aktyvus '+base+' planas</div><div class="moga-trial-copy">Bandymo metu sukurti duomenys išsaugoti MOGA Cloud. '+base+' planui nepriklausančių funkcijų duomenys taip pat lieka saugomi ir vėl bus pasiekiami pasirinkus atitinkamą aukštesnį planą.</div>';
    el.querySelector('.moga-trial-close')?.addEventListener('click',dismissPaidExpired);return;
  }
  el.innerHTML='<div class="moga-trial-kicker">MOGA SF · PREMIUM BANDYMAS</div><div class="moga-trial-copy">Bandomasis laikotarpis šiai paskyrai šiuo metu nepasiekiamas.</div>';
}
async function boot(){
  if(started)return;started=true;
  try{if(window.MOGA_CLOUD_READY)await window.MOGA_CLOUD_READY}catch(_){}
  await load();
  ['pointerdown','keydown','wheel','touchstart'].forEach(ev=>window.addEventListener(ev,touch,{passive:true}));
  document.addEventListener('visibilitychange',()=>{foreground=!document.hidden;if(foreground){lastActivity=Date.now();if(active())heartbeat(true)}else if(active())heartbeat(false)});
  window.addEventListener('focus',()=>{foreground=true;lastActivity=Date.now();if(active())heartbeat(true)});
  window.addEventListener('blur',()=>{foreground=false;if(active())heartbeat(false)});
  timer=setInterval(localTick,1000);
  heartbeatTimer=setInterval(()=>heartbeat(),HEARTBEAT_MS);
}
window.MOGA_TRIAL={get info(){return info},get active(){return active()},get eligible(){return eligible()},get effectivePlan(){return effectivePlan()},get remainingSeconds(){return remaining()},load,start:startTrial,heartbeat,render};
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot,{once:true});else boot();
})();
